import styled from "styled-components";

export const CardSkeleton = styled.div`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "100%"};
  background: linear-gradient(90deg, #EAEDF4 25%, #EAEDF4 50%, #EAEDF4 75%);
  background-size: 200% 100%;
  border-radius: 7px;
`;
